(function(){
  var root = document.querySelector('[data-static-handle="treatments"]');
  if (!root) return;
  var input = root.querySelector('[data-treatment-search]');
  var clear = root.querySelector('[data-treatment-clear]');
  var summary = root.querySelector('[data-treatment-summary]');
  var empty = root.querySelector('[data-treatment-empty]');
  var inputWrap = root.querySelector('.search-input-wrap');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-treatment-card]'));
  var lanes = Array.prototype.slice.call(root.querySelectorAll('[data-treatment-lane]'));

  function plural(n, word){ return n + ' ' + word + (n === 1 ? '' : 's'); }
  function updateCounts(){
    var visibleLanes = 0;
    var visibleCards = 0;
    lanes.forEach(function(lane){
      var laneCards = Array.prototype.slice.call(lane.querySelectorAll('[data-treatment-card]'));
      var laneVisible = laneCards.filter(function(card){ return !card.hidden; }).length;
      var count = lane.querySelector('[data-lane-count]');
      if (count) count.textContent = plural(laneVisible, 'product');
      lane.hidden = laneVisible === 0;
      if (laneVisible > 0) visibleLanes += 1;
      visibleCards += laneVisible;
    });
    if (summary) summary.textContent = visibleCards + ' products across ' + visibleLanes + ' categories';
    if (empty) empty.hidden = visibleCards !== 0;
  }
  function apply(){
    var q = (input && input.value || '').trim().toLowerCase();
    if (inputWrap) inputWrap.classList.toggle('has-query', q.length > 0);
    cards.forEach(function(card){
      var text = (card.getAttribute('data-search') || card.textContent || '').toLowerCase();
      card.hidden = q.length > 0 && text.indexOf(q) === -1;
    });
    updateCounts();
  }
  if (input) input.addEventListener('input', apply);
  if (clear) clear.addEventListener('click', function(){ if (input) { input.value = ''; input.focus(); } apply(); });
  apply();
})();